import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SpellingToolRepoService } from '@client/app/services/api/spelling-tool-repo/spelling-tool-repo.service';
import { ActiveRegionService } from '@client/app/blocks/service/active-region.service';
import { ControlContainer, NgForm } from '@angular/forms';
import { LOCALE_LANGUAGE_MAP } from '@client/app/modules/languages-ng2/constants/locale-language-map.constant';

@Component({
    selector: 'form-domain-detail',
    templateUrl: './form-domain-detail.component.html',
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
    standalone: false,
})
export class FormDomainDetailComponent implements OnInit {
    @Input() domain!: any;
    @Input() noLanguageSelector?: boolean;

    @Output() cmsValidityChange = new EventEmitter<boolean>();

    customers: any[] = [];
    languages: any[] = [];
    loadingLanguages = true;

    constructor (
        private spellingToolRepoService: SpellingToolRepoService,
        private activeRegionService: ActiveRegionService,
    ) {}

    ngOnInit () {
        this.activate();
    }

    private activate () {
        if (!this.domain.language) {
            this.setLanguage();
        }
        this.customers = [];
        this.languages = [];

        this.loadingLanguages = true;
        this.spellingToolRepoService.get().then((data: any) => {
            // Replace language names with correct ones from LOCALE_LANGUAGE_MAP
            this.languages = data.map((lang: any) => ({
                ...lang,
                name: LOCALE_LANGUAGE_MAP[lang.code as keyof typeof LOCALE_LANGUAGE_MAP] || lang.name,
            }));
            this.languages.sort((a, b) => {
                return a.name.localeCompare(b.name);
            });
            this.loadingLanguages = false;

            // Fallback to en_US if language is not found
            if (!this.languages.find(lang => lang.code === this.domain.language)) {
                this.domain.language = 'en_US';
            }
        }, () => {});
    }


    private setLanguage () {
        if (this.activeRegionService.isInRegion('AU')) {
            this.domain.language = 'en_AU';
        } else {
            this.domain.language = 'en_US';
        }
    }
}
